/**
 * A definition's CHANGE state: outlined (`.def-badge`), so it never reads
 * as one of a run's filled `.status-badge`s. Definitions are proposed in an
 * MR and enabled once on the default branch; runs have their own states.
 */

import type { ReactElement } from 'react';

export type DefinitionBadgeKind =
  | 'enabled'
  | 'proposed'
  | 'edit'
  | 'removal'
  | 'lint-warning'
  | 'lint-error'
  | 'policy-error';

interface DefinitionBadgeProps {
  kind: DefinitionBadgeKind;
  /** The MR an `edit` or `removal` is in. */
  mrIid?: number;
}

function copyFor(kind: DefinitionBadgeKind, mrIid: number | undefined): string {
  const mr = mrIid === undefined ? '' : ` in !${String(mrIid)}`;
  switch (kind) {
    case 'enabled':
      return 'enabled';
    case 'proposed':
      return 'proposed';
    case 'edit':
      return `edit${mr}`;
    case 'removal':
      return `removal${mr}`;
    case 'lint-warning':
      return '⚠ lint';
    case 'lint-error':
      return 'lint failed';
    case 'policy-error':
      return 'not allowed';
  }
}

export function DefinitionBadge({ kind, mrIid }: DefinitionBadgeProps): ReactElement {
  return <span className={`def-badge def-badge--${kind}`}>{copyFor(kind, mrIid)}</span>;
}
